export default {

    getCargoSegmentStatus: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/cargo-segment-status'
    },
    getDataCargoSegmentStatus: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/data-cargo-segment-status?status=STATUS'
    },

    getOrderAllocationStatus: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/order-allocation-status'
    },

    getDataOrderAllocationStatus: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/data-order-allocation-status?type=TYPE'
    },

    getShipmentLegTransportStatusInDay: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/shipment-leg-transport-status-in-day'
    },
    getDataShipmentLegTransportStatusInDay: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/data-shipment-leg-transport-status-in-day?type=TYPE'
    },

    getShipmentSchedulingStatus: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/shipment-scheduling-status'
    },
    getDataShipmentSchedulingStatus: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/data-shipment-scheduling-status?status=STATUS'
    },
    getOrderAllocationaVolume: {
        method: 'get',
        url: '/client/dashboard/direction-of-fleet/order-allocation-volume'
    }
}
